// extracted by mini-css-extract-plugin
module.exports = {"AutoPageTurn":"AutoPageTurn--36Ew4","prev":"prev--247ZP","next":"next--Wr9va"};